var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13 5.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m4 13.625C17 19.75 13.194 21 8.5 21S0 19.75 0 19.125C0 14.75 3.806 11 8.5 11s8.5 3.75 8.5 8.125m4.5-3.27A3.502 3.502 0 0 0 20.5 9a3.5 3.5 0 0 0-1.5 6.663V21l1.5 1.5 1-1 1-1-1-1L23 18l-1.5-1.5zM22 12.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0",
    clipRule: "evenodd"
  })));
});
const SvgPasskeysFilled = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPasskeysFilled);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMyA1LjVDMTMgNy45ODUyOCAxMC45ODUzIDEwIDguNSAxMEM2LjAxNDcyIDEwIDQgNy45ODUyOCA0IDUuNUM0IDMuMDE0NzIgNi4wMTQ3MiAxIDguNSAxQzEwLjk4NTMgMSAxMyAzLjAxNDcyIDEzIDUuNVpNMTcgMTkuMTI1QzE3IDE5Ljc1IDEzLjE5NDQgMjEgOC41IDIxQzMuODA1NTggMjEgMCAxOS43NSAwIDE5LjEyNUMwIDE0Ljc1IDMuODA1NTggMTEgOC41IDExQzEzLjE5NDQgMTEgMTcgMTQuNzUgMTcgMTkuMTI1Wk0yMS41IDE1Ljg1NTFDMjIuOTQ1NyAxNS40MjQ4IDI0IDE0LjA4NTUgMjQgMTIuNUMyNCAxMC41NjcgMjIuNDMzIDkgMjAuNSA5QzE4LjU2NyA5IDE3IDEwLjU2NyAxNyAxMi41QzE3IDEzLjg5NjIgMTcuODE3NSAxNS4xMDE1IDE5IDE1LjY2MzJWMjFMMjAuNSAyMi41TDIxLjUgMjEuNUwyMi41IDIwLjVMMjEuNSAxOS41TDIzIDE4TDIxLjUgMTYuNVYxNS44NTUxWk0yMiAxMi41QzIyIDEzLjMyODQgMjEuMzI4NCAxNCAyMC41IDE0QzE5LjY3MTYgMTQgMTkgMTMuMzI4NCAxOSAxMi41QzE5IDExLjY3MTYgMTkuNjcxNiAxMSAyMC41IDExQzIxLjMyODQgMTEgMjIgMTEuNjcxNiAyMiAxMi41WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";